export default __webpack_public_path__ + "static/system-info-49093d313166c6a5a7f3c1b734f1d775.png";